import { render, staticRenderFns } from "./subjectStatistics.vue?vue&type=template&id=4cd86927&scoped=true"
import script from "./subjectStatistics.vue?vue&type=script&lang=js"
export * from "./subjectStatistics.vue?vue&type=script&lang=js"
import style0 from "./subjectStatistics.vue?vue&type=style&index=0&id=4cd86927&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd86927",
  null
  
)

export default component.exports